export const ACTIVATE_TITLE_LEAD = 'Activate';
export const ACTIVATE_TITLE_TAIL = 'Account';
export const ACTIVATE_LOADING_LABEL = 'Activating your account.';
export const ACTIVATE_INVALID_LINK_MESSAGE
  = 'This activation link is no longer valid. Request a new activation email to continue.';
export const ACTIVATE_ALREADY_USED_MESSAGE
  = 'This activation link has already been used or is no longer valid. Request a new activation email to continue.';
export const ACTIVATE_LATER_ERROR_MESSAGE
  = 'We could not verify this activation link right now. Request a new activation email to continue.';
export const ACTIVATE_UNKNOWN_STATE_MESSAGE
  = 'We could not verify this activation link. Request a new activation email to continue.';
export const ACTIVATE_SUCCESS_TITLE = 'Account activated';
export const ACTIVATE_ERROR_TITLE = 'Account activation failed';
export const ACTIVATE_HELP_PROMPT = 'Need help?';
export const ACTIVATE_CONTACT_US_LABEL = 'Contact Us';
